import React from 'react';
import eu_funds_1 from '../../../assets/images/banners/EU_logo-zajedno-do-fondova.png';
import eu_funds_2 from '../../../assets/images/banners/EU-fondovi.png';
import I18n from '../../../blocks/localization';

const BannerEUFunds = () => (
    <a className="eufond_ban" href="https://www.promet-split.hr/eu-projekti/nabava-autobusa-koju-sufinancira-eu-iz-kohezijskog-fonda" target="_blank" rel="noopener noreferrer">
        <div className="title">
            <h4>{I18n.t('banners.euFundsTitle')}</h4>
            <img className="euflag" src={eu_funds_1} width="100" height="auto" alt="EU-fondovi" />
        </div>
        <img className="eufondsimg" src={eu_funds_2} alt="EU-fondovi" />
    </a>
);

export default BannerEUFunds;
